<main class="bg-white rounded-12px py-16px px-24px w-[80%]">
	<div class="flex items-center justify-between">
		<h1 class="text-font-18 font-DIN-Bold text-dark-grey">
			{{ 'SIDEBAR.POINTS_STATISTICS' | translate }}
		</h1>
		<div class="flex flex-col w-1/2">
			<div class="flex items-center justify-between">
				<mat-form-field (click)="pickerFrom.open()" class="mx-12px">
					<mat-label class="text-medium-gray">{{
						'GENERAL_LABELS.START_DATE' | translate
					}}</mat-label>

					<input
						#dateInput
						(dateChange)="changeDate()"
						[(ngModel)]="filter.fromDate"
						(keypress)="$event.preventDefault()"
						matInput
						[matDatepicker]="pickerFrom"
						[max]="today"
					/>
					<mat-datepicker-toggle matIconSuffix [for]="pickerFrom">
						<img
							matDatepickerToggleIcon
							src="./assets/images/calendar-search.svg"
						/>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerFrom></mat-datepicker>
				</mat-form-field>
				<mat-form-field (click)="pickerTo.open()" class="mx-12px">
					<mat-label class="text-medium-gray">{{
						'GENERAL_LABELS.END_DATE' | translate
					}}</mat-label>

					<input
						#dateInput
						(dateChange)="changeDate()"
						[(ngModel)]="filter.toDate"
						(keypress)="$event.preventDefault()"
						matInput
						[matDatepicker]="pickerTo"
						[max]="today"
					/>
					<mat-datepicker-toggle matIconSuffix [for]="pickerTo">
						<img
							matDatepickerToggleIcon
							src="./assets/images/calendar-search.svg"
						/>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerTo></mat-datepicker>
				</mat-form-field>

				<div
					(click)="
						filter.fromDate = ''; filter.toDate = ''; this.getStatistics()
					"
					class="flex items-center cursor-pointer"
				>
					<svg width="18" height="18" viewBox="0 0 18 18">
						<path
							d="M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z"
							fill="#DE0404"
						/>
						<path
							d="M6.87703 11.6845C6.73453 11.6845 6.59203 11.632 6.47953 11.5195C6.26203 11.302 6.26203 10.942 6.47953 10.7245L10.7245 6.47953C10.942 6.26203 11.302 6.26203 11.5195 6.47953C11.737 6.69703 11.737 7.05703 11.5195 7.27453L7.27453 11.5195C7.16953 11.632 7.01953 11.6845 6.87703 11.6845Z"
							fill="#DE0404"
						/>
						<path
							d="M11.122 11.6845C10.9795 11.6845 10.837 11.632 10.7245 11.5195L6.47953 7.27453C6.26203 7.05703 6.26203 6.69703 6.47953 6.47953C6.69703 6.26203 7.05703 6.26203 7.27453 6.47953L11.5195 10.7245C11.737 10.942 11.737 11.302 11.5195 11.5195C11.407 11.632 11.2645 11.6845 11.122 11.6845Z"
							fill="#DE0404"
						/>
					</svg>
					<span class="text-red-error text-font-14">{{
						'ACTIONS.RESET' | translate
					}}</span>
				</div>
			</div>
			<mat-error>
				<div
					class="whitespace-nowrap"
					*ngIf="filter.toDate < filter.fromDate && filter.toDate"
				>
					{{ 'VALIDATION.END_DATE_ERROR' | translate }}
				</div>
			</mat-error>
		</div>
	</div>
	<!-- CHART  -->
	<app-countries-tabs
		(countryId)="filter.countryId = $event; this.getStatistics()"
	></app-countries-tabs>
	<div *ngIf="labels?.length" id="chart">
		<apx-chart
			[series]="chartOptions?.series!"
			[chart]="chartOptions?.chart!"
			[labels]="chartOptions?.labels!"
			[responsive]="chartOptions?.responsive!"
			[legend]="legend"
			[plotOptions]="chartOptions?.plotOptions"
		></apx-chart>
	</div>
	<app-no-data-found *ngIf="!labels?.length"></app-no-data-found>
	<!-- CHART  -->
</main>
